import { getApstag } from '../../utils/callbacks';

/**
 * Promise that resolves with VAST 'cust_param' key-value pairs describing A9 bids.
 *
 * @returns {Promise<unknown>}
 */
export default (slotID) => new Promise((resolve, reject) => {
  const apstag = getApstag();
  const amazonTimeout = window.amazonVideoTimeout || 2000;

  if (! window.isApsVideoEnabled || 'function' !== typeof apstag.fetchBids) {
    reject();
    return;
  }

  const keys = ['amznbid', 'amzniid', 'amznp'];

  // Requests c.amazon-adsystem.com.
  apstag.fetchBids(
    {
      slots: [
        {
          slotID: slotID || 'instreamVideo',
          mediaType: 'video',
        },
      ],
      timeout: amazonTimeout,
    },
    (bids) => {
      if (! bids.length) {
        // eslint-disable-next-line no-console
        console.warn('Anvato: No A9 bids');

        resolve({});
        return;
      }

      const videoBids = bids.filter((bid) => 'video' === bid.mediaType);

      const params = {};
      videoBids.forEach((videoBid) => {
        // if deals are enabled, key-values are in the "targeting" attribute
        // and we include all of them
        if (videoBid.targeting) {
          const keyValues = videoBid.targeting;
          Object.keys(keyValues).forEach((key) => {
            params[key] = keyValues[key];
          });
        } else {
          // otherwise, keys are in the videoBid object, and we only include
          // specific keys related to targeting
          keys.forEach((key) => {
            if (key in videoBid) {
              params[key] = videoBid[key];
            }
          });
        }
      });

      resolve(params);
    },
  );
});
